import { render } from "./taskDetail.vue?vue&type=template&id=845f4a4c&scoped=true"
import script from "./taskDetail.vue?vue&type=script&lang=js"
export * from "./taskDetail.vue?vue&type=script&lang=js"

import "./taskDetail.vue?vue&type=style&index=0&id=845f4a4c&scoped=true&lang=css"
import "./taskDetail.vue?vue&type=style&index=1&id=845f4a4c&lang=css"

import exportComponent from "E:\\zhaojiaming\\smz2023\\fashengren\\speaker_h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-845f4a4c"]])

export default __exports__